var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E8343D;}\n\t.st1{fill:#3D9546;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#DC2235;}\n\t.st4{fill:none;}\n\t.st5{fill:#DB1F26;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 298.7,
    width: 512,
    y: 106.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 99.6,
    width: 362.7,
    x: 149.3,
    y: 305.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    height: 99.6,
    width: 362.7,
    x: 149.3,
    y: 106.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99,158.2h16c0.9,0,1.6,0.7,1.6,1.5v7.6c0,0.8-0.7,1.5-1.6,1.5H99c-0.9,0-1.6-0.7-1.6-1.5v-7.6   C97.4,158.9,98.2,158.2,99,158.2L99,158.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M115.1,168.9H99c-0.9,0-1.7-0.7-1.7-1.6v-7.6c0-0.9,0.8-1.6,1.7-1.6h16c0.9,0,1.7,0.7,1.7,1.6v7.6    C116.8,168.1,116,168.9,115.1,168.9L115.1,168.9z M99,158.3c-0.8,0-1.5,0.6-1.5,1.4v7.6c0,0.8,0.7,1.4,1.5,1.4h16    c0.8,0,1.5-0.6,1.5-1.4v-7.6c0-0.8-0.7-1.4-1.5-1.4H99L99,158.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99.4,158.6h15.2c0.8,0,1.5,0.6,1.5,1.4v6.9c0,0.8-0.7,1.4-1.5,1.4H99.4c-0.8,0-1.5-0.6-1.5-1.4V160   C97.9,159.2,98.6,158.6,99.4,158.6L99.4,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M114.7,168.4H99.4c-0.9,0-1.6-0.7-1.6-1.5V160c0-0.8,0.7-1.5,1.6-1.5h15.2c0.9,0,1.6,0.7,1.6,1.5v6.9    C116.3,167.8,115.6,168.4,114.7,168.4L114.7,168.4z M99.4,158.8c-0.8,0-1.4,0.6-1.4,1.3v6.9c0,0.7,0.6,1.3,1.4,1.3h15.2    c0.8,0,1.4-0.6,1.4-1.3V160c0-0.7-0.6-1.3-1.4-1.3H99.4L99.4,158.8z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "106.4,161.3 107.3,161.3 107.4,161.7 108.1,162.1 108.7,161.6 109.4,162 108.8,162.4 108.9,163    109.8,163 109.8,163.7 109.1,163.7 108.8,164.2 109.5,164.7 108.9,165.2 108.3,164.7 107.4,164.9 107.4,165.6 106.4,165.7    106.3,165 105.5,164.6 105,165.1 104.3,164.8 104.7,164.2 104.2,163.9 103.5,163.9 103.4,162.9 104.2,162.9 104.7,162.4    104.1,161.9 104.8,161.4 105.4,161.8 106.3,161.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "106.3,165.8 106.2,165 105.4,164.8 105.1,165.2 104.2,164.9 104.6,164.1 103.5,164 103.3,162.9     104.2,162.8 104.6,162.3 104,162 104.8,161.3 105.4,161.7 106,161.6 105.4,161.9 104.8,161.5 104.1,162 104.7,162.3 104.3,163     103.4,163 103.6,163.9 104.2,163.7 104.8,164.1 104.4,164.8 105.1,165 105.4,164.6 106.3,164.9 106.5,165.5 107.4,165.5     107.3,164.9 108.3,164.6 109,165.1 109.5,164.6 108.6,164.2 109,163.6 109.8,163.6 109.6,163 108.8,163.1 108.7,162.5     109.4,161.9 108.7,161.7 108.2,162.2 106.6,161.5 107.3,161.2 108.2,162 108.6,161.5 109.5,161.9 108.8,162.5 109.8,162.8     109.9,163.7 109.1,163.8 109.6,164.6 109,165.3 108.2,164.8 107.4,165 107.6,165.6 106.3,165.8   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106.7,162.5c0.6,0,1,0.4,1,0.9c0,0.5-0.5,0.9-1,0.9c-0.6,0-1-0.4-1-0.9C105.7,162.9,106.1,162.5,106.7,162.5   L106.7,162.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M106.7,164.3c-0.6,0-1.1-0.4-1.1-1c0-1.1,2.3-1.1,2.3,0C107.8,163.9,107.3,164.3,106.7,164.3L106.7,164.3z     M106.7,162.6c-0.5,0-0.9,0.3-0.9,0.7c0,0.8,1.8,0.8,1.8,0C107.6,162.9,107.2,162.6,106.7,162.6L106.7,162.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.4,159.1l-1.5,1.3L100.4,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M100.4,159.1l-1.5,1.3L100.4,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M101.4,159.1l-1.5,1.3L101.4,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M101.4,159.1l-1.5,1.3L101.4,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.4,159.1l-1.5,1.3L102.4,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M102.4,159.1l-1.5,1.3L102.4,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.4,159.1l-1.5,1.3L103.4,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M103.4,159.1l-1.5,1.3L103.4,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.3,159.1l-1.5,1.3L104.3,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M104.3,159.1l-1.5,1.3L104.3,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.3,159.1l-1.5,1.3L105.3,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M105.3,159.1l-1.5,1.3L105.3,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106.3,159.1l-1.5,1.3L106.3,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M106.3,159.1l-1.5,1.3L106.3,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.3,159.1l-1.5,1.3L107.3,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M107.3,159.1l-1.5,1.3L107.3,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.3,159.1l-1.5,1.3L108.3,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M108.3,159.1l-1.5,1.3L108.3,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.3,159.1l-1.5,1.3L109.3,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M109.3,159.1l-1.5,1.3L109.3,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M110.3,159.1l-1.5,1.3L110.3,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M110.3,159.1l-1.5,1.3L110.3,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M111.3,159.1l-1.5,1.3L111.3,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M111.3,159.1l-1.5,1.3L111.3,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.3,159.1l-1.5,1.3L107.3,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M107.3,159.1l-1.5,1.3L107.3,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M112.2,159.1l-1.5,1.3L112.2,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M112.2,159.1l-1.5,1.3L112.2,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M113.2,159.1l-1.5,1.3L113.2,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M113.2,159.1l-1.5,1.3L113.2,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M114.2,159.1l-1.5,1.3L114.2,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M114.2,159.1l-1.5,1.3L114.2,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M115.2,159.1l-1.5,1.3L115.2,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M115.2,159.1l-1.5,1.3L115.2,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M113.7,159.1l1.5,1.3L113.7,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M113.7,159.1l1.5,1.3L113.7,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M112.7,159.1l1.5,1.3L112.7,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M112.7,159.1l1.5,1.3L112.7,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M111.8,159.1l1.5,1.3L111.8,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M111.8,159.1l1.5,1.3L111.8,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M110.8,159.1l1.5,1.3L110.8,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M110.8,159.1l1.5,1.3L110.8,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.8,159.1l1.5,1.3L109.8,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M109.8,159.1l1.5,1.3L109.8,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.8,159.1l1.5,1.3L108.8,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M108.8,159.1l1.5,1.3L108.8,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.8,159.1l1.5,1.3L107.8,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M107.8,159.1l1.5,1.3L107.8,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106.8,159.1l1.5,1.3L106.8,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M106.8,159.1l1.5,1.3L106.8,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.8,159.1l1.5,1.3L105.8,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M105.8,159.1l1.5,1.3L105.8,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.8,159.1l1.5,1.3L104.8,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M104.8,159.1l1.5,1.3L104.8,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.9,159.1l1.5,1.3L103.9,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M103.9,159.1l1.5,1.3L103.9,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.9,159.1l1.5,1.3L102.9,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M102.9,159.1l1.5,1.3L102.9,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106.8,159.1l1.5,1.3L106.8,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M106.8,159.1l1.5,1.3L106.8,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M101.9,159.1l1.5,1.3L101.9,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M101.9,159.1l1.5,1.3L101.9,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.9,159.1l1.5,1.3L100.9,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M100.9,159.1l1.5,1.3L100.9,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99.9,159.1l1.5,1.3L99.9,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M99.9,159.1l1.5,1.3L99.9,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M98.9,159.1l1.5,1.3L98.9,159.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M98.9,159.1l1.5,1.3L98.9,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.4,166.5l-1.5,1.3L100.4,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M100.4,166.5l-1.5,1.3L100.4,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M101.4,166.5l-1.5,1.3L101.4,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M101.4,166.5l-1.5,1.3L101.4,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.4,166.5l-1.5,1.3L102.4,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M102.4,166.5l-1.5,1.3L102.4,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.4,166.5l-1.5,1.3L103.4,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M103.4,166.5l-1.5,1.3L103.4,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.3,166.5l-1.5,1.3L104.3,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M104.3,166.5l-1.5,1.3L104.3,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.3,166.5l-1.5,1.3L105.3,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M105.3,166.5l-1.5,1.3L105.3,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106.3,166.5l-1.5,1.3L106.3,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M106.3,166.5l-1.5,1.3L106.3,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.3,166.5l-1.5,1.3L107.3,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M107.3,166.5l-1.5,1.3L107.3,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.3,166.5l-1.5,1.3L108.3,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M108.3,166.5l-1.5,1.3L108.3,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.3,166.5l-1.5,1.3L109.3,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M109.3,166.5l-1.5,1.3L109.3,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M110.3,166.5l-1.5,1.3L110.3,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M110.3,166.5l-1.5,1.3L110.3,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M111.3,166.5l-1.5,1.3L111.3,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M111.3,166.5l-1.5,1.3L111.3,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.3,166.5l-1.5,1.3L107.3,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M107.3,166.5l-1.5,1.3L107.3,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M112.2,166.5l-1.5,1.3L112.2,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M112.2,166.5l-1.5,1.3L112.2,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M113.2,166.5l-1.5,1.3L113.2,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M113.2,166.5l-1.5,1.3L113.2,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M114.2,166.5l-1.5,1.3L114.2,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M114.2,166.5l-1.5,1.3L114.2,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M115.2,166.5l-1.5,1.3L115.2,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M115.2,166.5l-1.5,1.3L115.2,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M113.7,166.5l1.5,1.3L113.7,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M113.7,166.5l1.5,1.3L113.7,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M112.7,166.5l1.5,1.3L112.7,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M112.7,166.5l1.5,1.3L112.7,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M111.8,166.5l1.5,1.3L111.8,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M111.8,166.5l1.5,1.3L111.8,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M110.8,166.5l1.5,1.3L110.8,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M110.8,166.5l1.5,1.3L110.8,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.8,166.5l1.5,1.3L109.8,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M109.8,166.5l1.5,1.3L109.8,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.8,166.5l1.5,1.3L108.8,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M108.8,166.5l1.5,1.3L108.8,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.8,166.5l1.5,1.3L107.8,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M107.8,166.5l1.5,1.3L107.8,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106.8,166.5l1.5,1.3L106.8,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M106.8,166.5l1.5,1.3L106.8,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.8,166.5l1.5,1.3L105.8,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M105.8,166.5l1.5,1.3L105.8,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.8,166.5l1.5,1.3L104.8,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M104.8,166.5l1.5,1.3L104.8,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.9,166.5l1.5,1.3L103.9,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M103.9,166.5l1.5,1.3L103.9,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.9,166.5l1.5,1.3L102.9,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M102.9,166.5l1.5,1.3L102.9,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106.8,166.5l1.5,1.3L106.8,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M106.8,166.5l1.5,1.3L106.8,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M101.9,166.5l1.5,1.3L101.9,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M101.9,166.5l1.5,1.3L101.9,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.9,166.5l1.5,1.3L100.9,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M100.9,166.5l1.5,1.3L100.9,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99.9,166.5l1.5,1.3L99.9,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M99.9,166.5l1.5,1.3L99.9,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M98.9,166.5l1.5,1.3L98.9,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M98.9,166.5l1.5,1.3L98.9,166.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.4,157.7h16c0.9,0,1.6,0.7,1.6,1.5v7.6c0,0.8-0.7,1.5-1.6,1.5h-16c-0.9,0-1.6-0.7-1.6-1.5v-7.6   C32.8,158.4,33.5,157.7,34.4,157.7L34.4,157.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M50.4,168.4h-16c-0.9,0-1.7-0.7-1.7-1.6v-7.6c0-0.9,0.8-1.6,1.7-1.6h16c0.9,0,1.7,0.7,1.7,1.6v7.6    C52.2,167.7,51.4,168.4,50.4,168.4L50.4,168.4z M34.4,157.9c-0.8,0-1.5,0.6-1.5,1.4v7.6c0,0.8,0.7,1.4,1.5,1.4h16    c0.8,0,1.5-0.6,1.5-1.4v-7.6c0-0.8-0.7-1.4-1.5-1.4H34.4L34.4,157.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.8,158.2H50c0.8,0,1.5,0.6,1.5,1.4v6.9c0,0.8-0.7,1.4-1.5,1.4H34.8c-0.8,0-1.5-0.6-1.5-1.4v-6.9   C33.3,158.8,33.9,158.2,34.8,158.2L34.8,158.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M50,168H34.8c-0.9,0-1.6-0.7-1.6-1.5v-6.9c0-0.8,0.7-1.5,1.6-1.5H50c0.9,0,1.6,0.7,1.6,1.5v6.9    C51.7,167.3,50.9,168,50,168L50,168z M34.8,158.3c-0.8,0-1.4,0.6-1.4,1.3v6.9c0,0.7,0.6,1.3,1.4,1.3H50c0.8,0,1.4-0.6,1.4-1.3    v-6.9c0-0.7-0.6-1.3-1.4-1.3H34.8L34.8,158.3z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "41.8,160.8 42.7,160.9 42.7,161.3 43.5,161.7 44.1,161.2 44.8,161.6 44.1,162 44.3,162.6 45.1,162.5    45.1,163.3 44.4,163.3 44.1,163.8 44.9,164.3 44.3,164.7 43.7,164.3 42.7,164.5 42.8,165.2 41.8,165.2 41.6,164.6 40.8,164.2    40.3,164.7 39.6,164.3 40,163.8 39.5,163.4 38.8,163.4 38.8,162.4 39.5,162.5 40,161.9 39.4,161.5 40.2,161 40.7,161.4 41.6,161.2     "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "41.7,165.4 41.5,164.6 40.8,164.3 40.4,164.8 39.6,164.4 39.9,163.7 39.5,163.5 38.8,163.6     38.7,162.4 39.5,162.4 39.9,161.8 39.3,161.6 40.1,160.9 40.8,161.3 41.3,161.2 40.7,161.5 40.1,161.1 39.5,161.6 40.1,161.8     39.6,162.6 38.8,162.6 39,163.4 39.5,163.3 40.1,163.7 39.7,164.4 40.4,164.6 40.7,164.1 41.7,164.4 41.9,165.1 42.8,165     42.6,164.5 43.6,164.1 44.4,164.6 44.8,164.2 43.9,163.8 44.3,163.2 45.1,163.2 45,162.5 44.2,162.7 44,162 44.7,161.5 44,161.3     43.6,161.8 41.9,161 42.7,160.7 43.5,161.6 44,161.1 44.8,161.5 44.2,162.1 45.1,162.4 45.2,163.3 44.4,163.4 44.9,164.2     44.4,164.8 43.6,164.4 42.7,164.6 42.9,165.2 41.7,165.4   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42,162.1c0.6,0,1,0.4,1,0.9c0,0.5-0.5,0.9-1,0.9c-0.6,0-1-0.4-1-0.9C41,162.4,41.5,162.1,42,162.1L42,162.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M42,163.9c-0.6,0-1.1-0.4-1.1-1c0-1.1,2.3-1.1,2.3,0C43.2,163.5,42.7,163.9,42,163.9L42,163.9z M42,162.2    c-0.5,0-0.9,0.3-0.9,0.7c0,0.8,1.8,0.8,1.8,0C42.9,162.5,42.5,162.2,42,162.2L42,162.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.7,158.6l-1.5,1.3L35.7,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M35.7,158.6l-1.5,1.3L35.7,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.7,158.6l-1.5,1.3L36.7,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M36.7,158.6l-1.5,1.3L36.7,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.7,158.6l-1.5,1.3L37.7,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M37.7,158.6l-1.5,1.3L37.7,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.7,158.6l-1.5,1.3L38.7,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M38.7,158.6l-1.5,1.3L38.7,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.7,158.6l-1.5,1.3L39.7,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M39.7,158.6l-1.5,1.3L39.7,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M40.7,158.6l-1.5,1.3L40.7,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M40.7,158.6l-1.5,1.3L40.7,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41.7,158.6l-1.5,1.3L41.7,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M41.7,158.6l-1.5,1.3L41.7,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42.7,158.6l-1.5,1.3L42.7,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M42.7,158.6l-1.5,1.3L42.7,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.6,158.6l-1.5,1.3L43.6,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M43.6,158.6l-1.5,1.3L43.6,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.6,158.6l-1.5,1.3L44.6,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M44.6,158.6l-1.5,1.3L44.6,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.6,158.6l-1.5,1.3L45.6,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M45.6,158.6l-1.5,1.3L45.6,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M46.6,158.6l-1.5,1.3L46.6,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M46.6,158.6l-1.5,1.3L46.6,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42.7,158.6l-1.5,1.3L42.7,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M42.7,158.6l-1.5,1.3L42.7,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.6,158.6l-1.5,1.3L47.6,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M47.6,158.6l-1.5,1.3L47.6,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.6,158.6l-1.5,1.3L48.6,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M48.6,158.6l-1.5,1.3L48.6,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.6,158.6l-1.5,1.3L49.6,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M49.6,158.6l-1.5,1.3L49.6,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.6,158.6l-1.5,1.3L50.6,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M50.6,158.6l-1.5,1.3L50.6,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.1,158.6l1.5,1.3L49.1,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M49.1,158.6l1.5,1.3L49.1,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.1,158.6l1.5,1.3L48.1,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M48.1,158.6l1.5,1.3L48.1,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.1,158.6l1.5,1.3L47.1,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M47.1,158.6l1.5,1.3L47.1,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M46.1,158.6l1.5,1.3L46.1,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M46.1,158.6l1.5,1.3L46.1,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.1,158.6l1.5,1.3L45.1,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M45.1,158.6l1.5,1.3L45.1,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.1,158.6l1.5,1.3L44.1,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M44.1,158.6l1.5,1.3L44.1,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.1,158.6l1.5,1.3L43.1,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M43.1,158.6l1.5,1.3L43.1,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42.2,158.6l1.5,1.3L42.2,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M42.2,158.6l1.5,1.3L42.2,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41.2,158.6l1.5,1.3L41.2,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M41.2,158.6l1.5,1.3L41.2,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M40.2,158.6l1.5,1.3L40.2,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M40.2,158.6l1.5,1.3L40.2,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.2,158.6l1.5,1.3L39.2,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M39.2,158.6l1.5,1.3L39.2,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.2,158.6l1.5,1.3L38.2,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M38.2,158.6l1.5,1.3L38.2,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42.2,158.6l1.5,1.3L42.2,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M42.2,158.6l1.5,1.3L42.2,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.2,158.6l1.5,1.3L37.2,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M37.2,158.6l1.5,1.3L37.2,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.2,158.6l1.5,1.3L36.2,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M36.2,158.6l1.5,1.3L36.2,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.2,158.6l1.5,1.3L35.2,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M35.2,158.6l1.5,1.3L35.2,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.3,158.6l1.5,1.3L34.3,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M34.3,158.6l1.5,1.3L34.3,158.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.7,166.1l-1.5,1.3L35.7,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M35.7,166.1l-1.5,1.3L35.7,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.7,166.1l-1.5,1.3L36.7,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M36.7,166.1l-1.5,1.3L36.7,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.7,166.1l-1.5,1.3L37.7,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M37.7,166.1l-1.5,1.3L37.7,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.7,166.1l-1.5,1.3L38.7,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M38.7,166.1l-1.5,1.3L38.7,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.7,166.1l-1.5,1.3L39.7,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M39.7,166.1l-1.5,1.3L39.7,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M40.7,166.1l-1.5,1.3L40.7,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M40.7,166.1l-1.5,1.3L40.7,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41.7,166.1l-1.5,1.3L41.7,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M41.7,166.1l-1.5,1.3L41.7,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42.7,166.1l-1.5,1.3L42.7,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M42.7,166.1l-1.5,1.3L42.7,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.6,166.1l-1.5,1.3L43.6,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M43.6,166.1l-1.5,1.3L43.6,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.6,166.1l-1.5,1.3L44.6,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M44.6,166.1l-1.5,1.3L44.6,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.6,166.1l-1.5,1.3L45.6,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M45.6,166.1l-1.5,1.3L45.6,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M46.6,166.1l-1.5,1.3L46.6,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M46.6,166.1l-1.5,1.3L46.6,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42.7,166.1l-1.5,1.3L42.7,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M42.7,166.1l-1.5,1.3L42.7,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.6,166.1l-1.5,1.3L47.6,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M47.6,166.1l-1.5,1.3L47.6,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.6,166.1l-1.5,1.3L48.6,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M48.6,166.1l-1.5,1.3L48.6,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.6,166.1l-1.5,1.3L49.6,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M49.6,166.1l-1.5,1.3L49.6,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.6,166.1l-1.5,1.3L50.6,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M50.6,166.1l-1.5,1.3L50.6,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.1,166.1l1.5,1.3L49.1,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M49.1,166.1l1.5,1.3L49.1,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.1,166.1l1.5,1.3L48.1,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M48.1,166.1l1.5,1.3L48.1,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.1,166.1l1.5,1.3L47.1,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M47.1,166.1l1.5,1.3L47.1,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M46.1,166.1l1.5,1.3L46.1,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M46.1,166.1l1.5,1.3L46.1,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.1,166.1l1.5,1.3L45.1,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M45.1,166.1l1.5,1.3L45.1,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.1,166.1l1.5,1.3L44.1,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M44.1,166.1l1.5,1.3L44.1,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.1,166.1l1.5,1.3L43.1,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M43.1,166.1l1.5,1.3L43.1,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42.2,166.1l1.5,1.3L42.2,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M42.2,166.1l1.5,1.3L42.2,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41.2,166.1l1.5,1.3L41.2,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M41.2,166.1l1.5,1.3L41.2,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M40.2,166.1l1.5,1.3L40.2,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M40.2,166.1l1.5,1.3L40.2,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.2,166.1l1.5,1.3L39.2,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M39.2,166.1l1.5,1.3L39.2,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.2,166.1l1.5,1.3L38.2,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M38.2,166.1l1.5,1.3L38.2,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42.2,166.1l1.5,1.3L42.2,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M42.2,166.1l1.5,1.3L42.2,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.2,166.1l1.5,1.3L37.2,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M37.2,166.1l1.5,1.3L37.2,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.2,166.1l1.5,1.3L36.2,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M36.2,166.1l1.5,1.3L36.2,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.2,166.1l1.5,1.3L35.2,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M35.2,166.1l1.5,1.3L35.2,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.3,166.1l1.5,1.3L34.3,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M34.3,166.1l1.5,1.3L34.3,166.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63,179.9c-23.9,23.4-34.2,26.4-29.4,28.3c4.8,1.9,20.2-10.2,36.3-26.3c16-16.1,25.9-30.3,21.1-32.2   C86.2,147.8,88.4,155,63,179.9L63,179.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M34.7,208.5C34.7,208.5,34.7,208.5,34.7,208.5c-0.5,0-0.9-0.1-1.2-0.2c-0.8-0.3-1.2-0.6-1.2-1.1    c-0.2-1.1,1.7-2.6,5.9-5.9c5-3.9,13.3-10.5,24.6-21.6c13.8-13.5,19.5-21.8,22.5-26.2c2.6-3.8,3.2-4.9,5.6-4    c0.7,0.3,1.1,0.8,1.2,1.5c0.9,4.3-8.1,16.7-22.3,31C53.6,198.3,40.1,208.5,34.7,208.5L34.7,208.5z M89.7,149.5    c-1.3,0-2.1,1.2-4.1,4.2c-3,4.5-8.7,12.8-22.5,26.3c-11.3,11.1-19.7,17.6-24.6,21.6c-3.8,3-6,4.7-5.8,5.6c0,0.3,0.4,0.6,1.1,0.9    c0.3,0.1,0.7,0.2,1.1,0.2c0,0,0,0,0,0c5.3,0,18.8-10.1,35-26.4c14.2-14.2,23.1-26.5,22.2-30.7c-0.1-0.6-0.5-1.1-1.1-1.3    C90.4,149.6,90,149.5,89.7,149.5L89.7,149.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42.8,196.9l8.4,2.2c-7.9,7.5-16.8,10.6-19.2,9.2C29.5,207,36.4,204,42.8,196.9L42.8,196.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33.5,208.8c-0.7,0-1.2-0.1-1.6-0.3c-0.4-0.2-0.5-0.4-0.6-0.7c-0.1-0.9,1.4-2.1,3.7-3.9c2.1-1.7,5-4,7.7-7    l8.5,2.2C44.7,205.4,37.2,208.8,33.5,208.8L33.5,208.8z M42.8,197c-2.6,3-5.5,5.3-7.6,7c-2.1,1.7-3.6,2.9-3.6,3.7    c0,0.2,0.2,0.4,0.4,0.5c2.4,1.3,11.5-2,19.1-9.2L42.8,197L42.8,197z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42.8,197.8l6.9,1.8c-7.7,7.2-15.3,9.2-17.3,8.4C30.5,207,36.6,204.6,42.8,197.8L42.8,197.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33.6,208.2c-0.5,0-0.9-0.1-1.2-0.2l-0.5-0.5c-0.1-0.6,1-1.4,2.8-2.8c2.1-1.6,5-3.8,7.9-7l7,1.7    C43.1,205.9,36.4,208.2,33.6,208.2L33.6,208.2z M42.8,197.9c-2.9,3.2-5.7,5.4-7.9,7c-1.6,1.2-2.8,2.1-2.7,2.6    c0.6,0.4,0.9,0.5,1.4,0.5c2.8,0,9.3-2.3,16-8.5L42.8,197.9L42.8,197.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M65.3,181.8c0.2-0.8,0.2-1,0.1-1.2l0.2,0.2l0.1-0.3l0.1,0.6c0.7,0.3,0.9,0.3,1.1,0.2c0.2-0.1,0.5-0.2,0.6-0.3    l0.5-0.4c0.2-0.5,0.3-0.7,0.3-1c0.1-0.2,0.1-0.7,0.1-0.8l0.2,0c0,0.1-0.1,0.6-0.1,0.8c0,0.3,0,0.5-0.1,0.7l-0.4,0.5    c-0.1,0.2-0.2,0.3-0.5,0.4c-0.2,0.1-0.4,0.2-0.6,0.3c-0.3,0.1-0.5,0.1-0.8,0.1l-0.5-0.3L65.3,181.8L65.3,181.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.6,184.1l-0.4,0c-0.1,0.1-0.3,0-0.4,0l0-0.1l-0.6,0l0.4-0.2l0.3,0.1l0.5-0.9c0.1-0.1,0.2-0.3,0.4-0.4    l0.6-0.4c0.3-0.1,0.5-0.1,0.8-0.1h0.9c0.3,0.1,0.6,0.1,0.8,0.2l0.2,0.4l-0.1-0.1c-0.5-0.2-0.7-0.3-1-0.3l-0.8,0    c-0.3,0-0.5,0-0.8,0.1l-1.5,1.5l0.2,0c0,0,0,0,0,0C62.4,184,62.5,184,62.6,184.1L62.6,184.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M59.4,188.8l0.3-0.5c0,0-0.3-0.3-0.4-0.5l-0.3-0.6l0.4-0.6l1.5-0.8l0.5-0.5l0,0.4l-0.8,0.4l0.1,0.1l-1.3,0.8    l0,0l0.6,1.2l0,0L59.4,188.8L59.4,188.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M56.1,191.9c-0.4,0-0.5-0.3-0.6-0.5l-0.1-0.7c0-0.3,0-0.5,0.1-0.8l0.4-0.5l1.4-0.8h0.9c0.3,0.1,0.8,0.2,1,0.3    l-0.1,0.2c-0.2,0-0.7-0.2-0.9-0.3l-1.5,0.1l0.1,0.1c-0.2,0.2-0.3,0.3-0.6,0.4l-0.5,0.5l0.1,0c-0.1,0.2-0.1,0.4-0.1,0.7l0,0.6    l0.1,0C55.8,191.5,55.9,191.7,56.1,191.9L56.1,191.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "53.3,194.8 52.9,194.6 54.1,194.3 54.7,193.6 54.7,193 54.7,192.6 54.7,192.5 54.7,192.5 54.7,192.5     54.4,192.2 54.7,192.5 54.5,192.3 54.1,191.7 55.1,193.1 55.3,193.1 55.5,193.2 56.3,192.8 56.1,193.2 55.5,193.4 55,193.1     54.9,193.7 53.3,194.8   "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M48.7,198l-0.1-0.3c0-0.3,0-0.5-0.1-0.7l-0.3-1.3l1.1,1.1l0.8,0.3c0.9,0,1.1,0,1.3-0.1l0.5-0.4    c0.2-0.7,0.2-1,0.1-1.2l-0.5-1l0.3,0.2l0.5,0.8c0.1,0.2,0.1,0.5,0.1,0.8l-0.2,0.6l-0.6,0.5c-0.3,0-0.5,0.1-0.8,0.1    c-0.1,0.1-0.5,0.1-0.7,0c-0.2,0-0.4-0.1-0.6-0.2l-1-0.8l0.3,0.7l0.1,0c0.1,0.2,0.1,0.5,0.1,0.7L48.7,198L48.7,198z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M35.9,206.3c-0.5,0-0.8-0.1-0.9-0.1c0.2-0.2,0.5-0.1,0.9-0.1c0.5-0.1,0.7-0.2,0.8-0.3c0.1-0.3,0.1-0.4,0-0.6    c-0.2-0.3-0.2-0.6-0.1-1c0.1-0.4,0.3-0.7,0.6-0.9c0.2-0.2,0.5-0.2,0.8-0.2c0.5,0.1,0.9,0.3,1.3,0.5l0.6,0.6L40,204    c0.2,0.1,0.4,0.2,0.7,0.2c-0.2,0.3-0.5,0.2-0.8,0l-0.7-0.5c-0.3-0.2-0.7-0.4-1-0.5l0,0l-0.8,0.1c-0.2,0.1-0.4,0.4-0.5,0.7    c-0.1,0.4-0.1,0.6,0.1,0.8c0.2,0.4,0.2,0.5,0,0.9c-0.2,0.3-0.5,0.3-0.8,0.4C36.1,206.3,36,206.3,35.9,206.3L35.9,206.3z     M43.6,203.1c-0.2-0.3-0.3-0.8-0.4-1c-0.1-0.4-0.1-0.7-0.2-0.8c-0.2-0.2-0.4-0.4-0.6-0.5l-0.1-0.1l0.2,0.4c-0.4,0.3-0.6,0.4-1,0.4    c-0.5,0-0.7-0.2-0.9-0.4l-0.5,1.5l0.4-1.4l0.3-0.2c0.2,0.2,0.2,0.3,0.7,0.3c0.4,0,0.5-0.1,0.7-0.2c0-0.3,0-0.4-0.3-0.5l0.1-0.2    l0.6,0.3c0.2,0.1,0.4,0.3,0.6,0.5c0.2,0.2,0.2,0.5,0.2,0.7c0.1,0.5,0.2,0.9,0.3,1.1c0.3-0.1,0.4-0.1,0.6-0.2l0.2-0.6l-0.1-0.1    c0-0.4,0-0.6,0.3-0.8c0.2-0.2,0.5-0.2,0.8-0.2c0.5,0,0.8-0.1,1.1-0.3c-0.1-0.7-0.2-0.7-0.5-0.9c-0.3-0.2-0.5-0.3-0.9-0.3l-0.7,0.4    c-0.4,0.1-0.8,0.1-1-0.2l0.1-0.5v0.1c0.2,0.4,0.5,0.4,0.8,0.3c0.3-0.3,0.4-0.4,0.8-0.5c0.5,0,0.7,0.1,1,0.3    c0.4,0.2,0.6,0.3,0.8,0.6l-0.2,0.7c-0.2,0.2-0.6,0.3-1,0.3l0,0l-0.8,0.1c-0.2,0.2-0.2,0.3-0.2,0.7l-0.3,0.9    C44.2,203.1,44,203.1,43.6,203.1L43.6,203.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M90.3,158.8c10.6-18.3,17.7-34,15.7-34.9c-1.9-0.9-12.1,13.3-22.8,31.6L90.3,158.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M90.4,158.9l-7.1-3.3c10.2-18,20.2-31.9,22.6-31.9l0.6,0.5C107.2,126.8,100.4,141.7,90.4,158.9L90.4,158.9    L90.4,158.9z M106.1,124.3c-2.7,0-12.7,14.1-22.7,31.3l6.9,3C100,141.8,107,126.7,106.1,124.3    C106.2,124.3,106.1,124.3,106.1,124.3L106.1,124.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89.6,158.4c10.3-17.7,17.3-32.6,15.8-33.4c-1.6-0.7-11.1,13.1-21.4,30.8L89.6,158.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M89.7,158.5l-0.2-0.1c9.6-16.5,16.6-31,15.9-33c-1.5-0.7-10.3,11.5-21.3,30.6c8.9-15.9,19.5-31.8,21.3-31    C106.3,127.4,99.5,141.6,89.7,158.5L89.7,158.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M87.8,149.2c-1.3,2.1-2.6,4.4-3.9,6.6l5.6,2.6c1.3-2.2,2.7-4.5,3.8-6.6L87.8,149.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M89.6,158.6l-5.7-2.6l1.3-2.5c0.9-1.5,1.7-3,2.5-4.3l5.8,2.5c-0.8,1.7-1.7,3.3-2.7,4.9L89.6,158.6L89.6,158.6    z M87.8,149.3c-0.7,1.3-1.5,2.8-2.4,4.3l-1.3,2.3l5.5,2.4l1.1-1.8c0.9-1.6,1.9-3.2,2.7-4.7L87.8,149.3L87.8,149.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M88.3,149.9c-1.3,2.1-2.1,3.7-3.4,5.9l4.2,1.9c1.3-2.2,2.2-3.8,3.4-5.9L88.3,149.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M89.2,157.9l-4.3-2l1.2-2.4c0.7-1.2,1.3-2.3,2.1-3.6l4.4,1.9c-0.7,1.5-1.3,2.6-2,3.8L89.2,157.9L89.2,157.9z     M88.3,150c-0.6,1.3-1.3,2.4-2,3.6l-1.3,2.2l4.1,1.7l1.3-2.2c0.7-1.2,1.3-2.3,2.1-3.6L88.3,150L88.3,150z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "91.4,152.3 88.6,151 86.1,155.3 88.9,156.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M88.9,156.8l-2.9-1.3l2.4-4.5l3,1.2L88.9,156.8L88.9,156.8z M88.5,151.1l-2.3,4.3l2.6,1.1l2.4-4.2L88.5,151.1    L88.5,151.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.4,152.3l-5.3,3L91.4,152.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "86.1,155.4 91.3,152.2 91.4,152.4 86.1,155.4   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M88.9,156.6l-0.3-5.6L88.9,156.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "88.7,156.6 88.4,151 89,156.6 88.7,156.6   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104,130.4l-2.8-1.3L104,130.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "104,130.5 101.2,129.2 104.1,130.3 104,130.5   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M103.7,127c-0.4,0.1-0.7,0.5-0.6,0.9c0.1,0.4,0.5,0.6,1,0.5c0.4-0.1,0.7-0.5,0.6-0.9   C104.6,127.1,104.1,126.9,103.7,127L103.7,127z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M103.7,127c-0.4,0.1-0.7,0.5-0.6,0.9c0.1,0.4,0.5,0.6,1,0.5c0.4-0.1,0.7-0.5,0.6-0.9    C104.6,127.1,104.1,126.9,103.7,127z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M86.2,179.4c23.9,23.4,34.2,26.4,29.4,28.3c-4.8,1.9-20.2-10.2-36.3-26.3c-16-16.1-25.9-30.4-21.1-32.2   C63,147.3,60.7,154.5,86.2,179.4L86.2,179.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M114.4,208c-5.4,0-18.9-10.2-35.2-26.5c-14.2-14.2-23.2-26.7-22.3-31c0.2-0.7,0.6-1.2,1.2-1.5    c2.4-1,3,0.2,5.6,4c3,4.5,8.7,12.8,22.5,26.2c11.3,11.1,19.6,17.6,24.6,21.5c4.2,3.3,6.1,4.8,5.9,5.9c-0.1,0.4-0.4,0.8-1.2,1.1    C115.2,208,114.8,208,114.4,208L114.4,208z M59.4,149.1c-0.3,0-0.7,0.1-1.2,0.3c-0.6,0.2-0.9,0.7-1.1,1.3    c-0.9,4.2,8,16.6,22.2,30.7c17.6,17.6,31.8,28,36.1,26.2c0.7-0.3,1-0.5,1.1-0.9c0.1-0.9-2-2.6-5.8-5.6c-5-3.9-13.3-10.5-24.6-21.6    c-13.8-13.5-19.5-21.8-22.5-26.3C61.5,150.3,60.7,149.1,59.4,149.1L59.4,149.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106.3,196.5l-8.4,2.2c7.9,7.5,16.8,10.6,19.2,9.2C119.7,206.6,112.7,203.5,106.3,196.5L106.3,196.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M115.7,208.3c-3.7,0-11.2-3.4-17.8-9.6l8.4-2.4c2.9,3.1,5.8,5.4,7.9,7.1c2.3,1.8,3.7,3,3.7,3.9    c0,0.3-0.2,0.5-0.6,0.7C116.8,208.2,116.3,208.3,115.7,208.3L115.7,208.3z M106.2,196.6l-8.3,2.2c6.6,6,14,9.3,17.7,9.3l0,0    c0.6,0,1.1-0.1,1.5-0.3c0.3-0.2,0.4-0.3,0.4-0.5c0.1-0.7-1.5-2-3.6-3.7C111.9,201.9,109,199.6,106.2,196.6L106.2,196.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106.3,197.4l-6.9,1.8c7.7,7.2,15.3,9.2,17.3,8.4C118.7,206.6,112.6,204.1,106.3,197.4L106.3,197.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M115.5,207.8c-2.8,0-9.4-2.3-16.2-8.6l7-2c3.1,3.3,6,5.5,8.1,7.1c1.9,1.4,2.9,2.2,2.8,2.8l0,0.1l-0.4,0.4    C116.4,207.7,116,207.8,115.5,207.8L115.5,207.8z M106.2,197.4l-6.8,1.8c7.9,7.1,15.3,8.9,17.2,8.1c0.4-0.7-0.8-1.6-2.4-2.9    C112.2,203,109.2,200.7,106.2,197.4L106.2,197.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M83.7,181.3l-0.4-0.4l-0.4,0.3c-0.3,0.1-0.6,0.1-0.8,0c-0.2-0.1-0.5-0.2-0.6-0.3c-0.2-0.1-0.3-0.2-0.5-0.4    l-0.4-0.6l-0.1-1.1l0.2-0.3l0.2,1.4l0.8,0.9c0.1,0.1,0.3,0.2,0.6,0.3c0.2,0.1,0.4,0.1,0.7,0l0.5-0.2c0-0.2,0.1-0.5,0.1-0.7    l0.1,0.7l0,0L83.7,181.3L83.7,181.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M87.2,183.4l-1.7-1.6l0,0.1c-0.2-0.1-0.4-0.1-0.8-0.1h-0.9c-0.3,0.1-0.5,0.1-0.8,0.2l-0.4,0l0.1-0.1    c0.5-0.2,0.8-0.3,1.1-0.4l0.9,0c0.3,0,0.6,0,0.8,0.1l0.6,0.5l0.1-0.1L87.2,183.4L87.2,183.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M89.9,188.3l-0.9-0.2l0.8-1.6l-0.3-0.2c-0.7-0.3-0.9-0.4-1.1-0.5l-0.6-0.3l-0.3-0.6c-0.6,0.2-0.9,0.1-1.2,0.1    l-0.1-0.3l0.1,0c0.2,0,0.6,0.1,0.7,0l0.7-0.4l0.2,0.9l2,1.3c0.1,0.5,0,0.7-0.2,0.9l-0.4,0.6L89.9,188.3L89.9,188.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M93.2,191.6c0-0.3,0.1-0.5,0.1-0.8l0.1-0.6c0-0.2,0-0.5-0.1-0.7l-0.4-0.6l-0.1,0.1c-0.2-0.1-0.4-0.2-0.6-0.4    l-0.6-0.3v0.1h-0.9c-0.2,0.1-0.7,0.2-0.9,0.3l-0.1-0.2c0.2,0,0.7-0.2,0.9-0.3l0.9,0l0.8,0.3c0.2,0.2,0.3,0.3,0.5,0.4    c0.3,0.3,0.5,0.5,0.6,0.7c0.1,0.2,0.1,0.5,0.1,0.8l-0.1,0.7C93.5,191.2,93.4,191.4,93.2,191.6L93.2,191.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "96.3,194.3 95.3,194.2 94.6,193.5 94.2,192.6 93.9,192.8 93.6,192.8 94.5,191.6 94.4,191.9     94.5,191.9 94.5,192.2 94.5,192.2 94.3,192.6 94.5,193.2 95.4,194.1 95.9,194.1 97.7,193.4 98,193.8 97.6,193.6 97.6,193.7     96.3,194.3   "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M100.7,197.9l-0.4-0.6c0-0.4,0-0.6,0.1-0.8l0.3-0.5l-0.1,0l-1.5,0.9l0.1,0.1c-0.2,0.1-0.6,0.1-0.7,0    c-0.2,0-0.5,0-0.7-0.1l-0.9-1.1c0-0.4,0-0.6,0.1-0.8l0.3-0.7l0.5-0.2l-0.5,0.5l0,0.4l0,0.6l0.2,0.6c0.7,0.4,0.9,0.4,1.1,0.4l0,0    l0.6,0l1.2-0.4l0.6-1l0,0.2l0.1-0.2l0.1,0.1l-0.5,1.2l-0.2,0.7l0.1,0L100.7,197.9L100.7,197.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M113.2,205.9c-0.6-0.1-0.9-0.2-1.1-0.4c-0.2-0.4-0.2-0.6,0-0.9c0.2-0.2,0.2-0.4,0.1-0.9    c-0.1-0.3-0.3-0.6-0.5-0.7l-0.6-0.1c-0.5,0.1-0.8,0.2-1.2,0.5l-0.7,0.5c-0.4,0.2-0.7,0.2-1.2,0.2l0.8-1.6l0.1-0.6l-0.4-0.4    l-0.3-0.9c0,0.3-0.1,0.5-0.6,0.5h0c-0.4,0-0.6-0.1-0.8-0.2c-0.1-0.2-0.1-0.4-0.1-0.5c-0.2,0.2-0.4,0.3-0.6,0.5l-0.2,0.8    c-0.1,0.3-0.2,0.7-0.3,0.9c-0.5,0.1-0.7,0-1-0.1l-0.2-0.8c0-0.4,0-0.6-0.2-0.8c-0.1-0.1-0.3-0.1-0.6-0.1c-0.6,0-0.9-0.2-1.2-0.3    l-0.2-0.7c0.2-0.4,0.4-0.5,0.8-0.6c0.3-0.2,0.5-0.3,1-0.3c0.4,0.1,0.6,0.2,0.7,0.3c0.4,0.2,0.8,0.2,0.9,0l0.3-0.3v0.1    c-0.3,0.6-0.8,0.7-1.1,0.6L104,199l0,0.1c-0.4,0-0.6,0.1-0.8,0.3c-0.4,0.2-0.5,0.2-0.7,0.5c0.4,0.5,0.7,0.6,1,0.7    c0.5,0,0.7,0,0.9,0.2c0.3,0.3,0.3,0.5,0.3,0.9l0,0.8l0-0.1c0.2,0.1,0.3,0.1,0.7,0.1c0-0.2,0.1-0.6,0.1-0.8    c0.1-0.5,0.1-0.8,0.3-0.9c0.2-0.2,0.4-0.4,0.6-0.6l0.3-0.2c0.1,0,0.1-0.1,0.2-0.1l0,0l0.2-0.1l-0.5,0.9c0.3,0,0.4,0.1,0.7,0.1    c0.4,0,0.5-0.1,0.7-0.3l0.1-0.2l0.7,2.3l-0.2,0.8c0,0.2-0.1,0.4-0.2,0.5c0.1,0,0.3-0.1,0.5-0.2l0.8-0.4l-0.1-0.1    c0.3-0.2,0.7-0.4,1.1-0.5c0.5,0,0.8,0,1,0.2c0.2,0.1,0.4,0.4,0.5,0.8c0.1,0.4,0.1,0.7-0.1,1c-0.1,0.2-0.2,0.3,0,0.6    c0.1,0.2,0.4,0.2,0.7,0.3c0.5,0,0.8,0,1-0.1C113.8,205.8,113.5,205.9,113.2,205.9L113.2,205.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.8,158.3c-10.6-18.3-17.7-34-15.7-34.9c1.9-0.9,12.1,13.3,22.8,31.6L58.8,158.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.8,158.5L58.8,158.5c-10-17.3-16.9-32.2-16.1-34.7l0.6-0.5c2.4,0,12.4,13.9,22.7,31.7L58.8,158.5    L58.8,158.5z M43.3,123.5c-1.1,2.7,5.9,17.8,15.6,34.6l6.9-3.2C55.7,137.7,45.6,123.5,43.3,123.5L43.3,123.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.5,158c-10.3-17.7-17.3-32.6-15.8-33.4c1.6-0.7,11.1,13.1,21.4,30.8L59.5,158z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M59.4,158.1c-9.8-16.8-16.6-31.1-15.9-33.2c0.1-0.1,0.2-0.1,0.3,0c-0.7,2.2,6.3,16.7,15.8,33.2L59.4,158.1    L59.4,158.1z M65.3,155.3c-9.2-15.5-16.8-26.4-20-29.7C49.2,129.2,57.7,142.3,65.3,155.3L65.3,155.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.3,148.8c1.3,2.1,2.6,4.4,3.8,6.6l-5.6,2.6c-1.3-2.2-2.7-4.5-3.8-6.6L61.3,148.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M59.5,158.2l-1.5-2.6c-0.8-1.4-1.7-2.9-2.4-4.2l5.7-2.8c1,1.5,2,3.1,2.9,4.7l1.1,2L59.5,158.2L59.5,158.2z     M61.2,148.8l-5.5,2.6c0.8,1.2,1.6,2.6,2.5,4l1.4,2.4l5.5-2.5l-1.2-1.8C63,151.9,62.1,150.3,61.2,148.8L61.2,148.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.8,149.5c1.3,2.1,2.1,3.7,3.4,5.9l-4.2,1.9c-1.3-2.2-2.2-3.8-3.4-5.9L60.8,149.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M60,157.4l-1.2-2.1c-0.7-1.3-1.4-2.4-2.2-3.8l4.3-2.1c0.9,1.4,1.6,2.5,2.3,3.7l1.3,2.2L60,157.4L60,157.4z     M60.7,149.5l-4,2c0.8,1.2,1.5,2.4,2.3,3.7l1.1,1.9l4.1-1.9l-1.3-2.1C62.1,152,61.5,150.8,60.7,149.5L60.7,149.5z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "57.8,151.9 60.6,150.6 63.1,154.9 60.3,156.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M60.2,156.3l-2.5-4.4l2.9-1.5l2.6,4.3L60.2,156.3L60.2,156.3z M60.5,150.6l-2.7,1.3l2.5,4l2.7-1.3L60.5,150.6    L60.5,150.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.8,151.9l5.3,3L57.8,151.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "63.1,154.8 57.7,152 57.8,151.8 63.1,154.8   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.3,156.2l0.3-5.6L60.3,156.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M60.3,156.2l0.3-5.6L60.3,156.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.1,130l2.8-1.3L45.1,130z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M45.1,130l2.8-1.3L45.1,130z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M45.4,126.6c0.4,0.1,0.7,0.5,0.6,0.9c-0.1,0.4-0.5,0.6-1,0.5c-0.4-0.1-0.7-0.5-0.6-0.9S45,126.4,45.4,126.6   L45.4,126.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45.3,128.1l-0.3,0c-0.4-0.1-0.8-0.6-0.7-1c0.1-0.4,0.4-0.6,0.9-0.6c0.8,0.2,1.1,0.6,1,1.1    C46.1,127.8,45.7,128.1,45.3,128.1L45.3,128.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.3,148.9c0,15.4,0.1,21.2-1,22c-1.1,0.9-31,0-31,4.4c0,4.4,24.7,8.8,32.1,8.8c9.9,0,14.8-4.4,14.8-13.2v-22   H67.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M67.3,184.3c-7.2,0-32.2-4.3-32.2-8.9c0-3.2,14.4-3.7,23.9-4c3.7-0.1,6.9-0.2,7.1-0.5c1-0.7,1-6,1-18.9l0-3    l14.9-0.1l0.1,22.1C82.3,179.8,77.2,184.3,67.3,184.3L67.3,184.3z M82,148.9l-14.7,0.1l0.1,2.9c0,13.3,0,18.3-1.1,19.1    c-0.3,0.3-2.7,0.4-7.3,0.5c-8.9,0.3-23.7,0.8-23.7,3.8c0,4.2,24,8.7,32,8.7c9.7,0,14.7-4.4,14.7-13.1V148.9L82,148.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.3,153.3v2.2c4.9,0.7,9.9,0.7,14.8,0v-2.2C77.2,154.1,72.3,154.1,67.3,153.3L67.3,153.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74.7,156.2c-2.5,0-5-0.2-7.4-0.6l-0.1-2.3c5.2,0.5,10,0.6,14.9-0.1l0.1,2.3C79.7,156,77.2,156.2,74.7,156.2    L74.7,156.2z M67.3,153.5l0.1,2.1c4.7,0.5,9.8,0.6,14.7-0.1l-0.1-2.1C77.4,154.3,72.2,154.2,67.3,153.5L67.3,153.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.3,148.9v2.2c4.9,0.7,9.9,0.7,14.8,0v-2.2C77.2,149.7,72.3,149.7,67.3,148.9L67.3,148.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74.7,151.8c-2.5,0-5-0.2-7.4-0.6l-0.1-2.3c5.2,0.5,10,0.6,14.9-0.1l0.1,2.3    C79.7,151.6,77.2,151.8,74.7,151.8L74.7,151.8z M67.3,149.1l0.1,2.1c4.7,0.5,9.8,0.6,14.7-0.1l-0.1-2.1    C77.4,149.9,72.2,149.8,67.3,149.1L67.3,149.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.3,151.1v2.2c4.9,0.7,9.9,0.7,14.8,0v-2.2C77.2,151.9,72.3,151.9,67.3,151.1L67.3,151.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74.7,154c-2.5,0-5-0.2-7.4-0.6l-0.1-2.3c5.2,0.5,10,0.6,14.9-0.1l0.1,2.3C79.7,153.8,77.2,154,74.7,154    L74.7,154z M67.3,151.3l0.1,2.1c4.7,0.5,9.8,0.6,14.7-0.1l-0.1-2.1C77.4,152.1,72.2,152,67.3,151.3L67.3,151.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.3,155.5v2.2c4.9,0.7,9.9,0.7,14.8,0v-2.2C77.2,156.3,72.3,156.3,67.3,155.5L67.3,155.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74.7,158.4c-2.5,0-5-0.2-7.4-0.6l-0.1-2.3c5.2,0.5,10,0.6,14.9-0.1l0.1,2.3    C79.7,158.2,77.2,158.4,74.7,158.4L74.7,158.4z M67.3,155.7l0.1,2.1c4.7,0.5,9.8,0.6,14.7-0.1l-0.1-2.1    C77.4,156.5,72.2,156.4,67.3,155.7L67.3,155.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68,151.9c0.4,0,0.7,0.2,0.7,0.5c0,0.3-0.3,0.5-0.7,0.5s-0.7-0.2-0.7-0.5C67.3,152.1,67.6,151.9,68,151.9   L68,151.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 68,
    cy: 152.4,
    rx: 0.7,
    ry: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.7,152.2c0.4,0,0.7,0.2,0.7,0.5c0,0.3-0.3,0.5-0.7,0.5s-0.7-0.2-0.7-0.5C70,152.4,70.3,152.2,70.7,152.2   L70.7,152.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 70.7,
    cy: 152.6,
    rx: 0.7,
    ry: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.4,152.4c0.4,0,0.7,0.2,0.7,0.5c0,0.3-0.3,0.5-0.7,0.5c-0.4,0-0.7-0.2-0.7-0.5   C72.7,152.6,73,152.4,73.4,152.4L73.4,152.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M73.4,152.4c0.4,0,0.7,0.2,0.7,0.5c0,0.3-0.3,0.5-0.7,0.5c-0.4,0-0.7-0.2-0.7-0.5    C72.7,152.6,73,152.4,73.4,152.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M76.1,152.4c0.4,0,0.7,0.2,0.7,0.5c0,0.3-0.3,0.5-0.7,0.5c-0.4,0-0.7-0.2-0.7-0.5   C75.4,152.6,75.7,152.4,76.1,152.4L76.1,152.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M76.1,152.4c0.4,0,0.7,0.2,0.7,0.5c0,0.3-0.3,0.5-0.7,0.5c-0.4,0-0.7-0.2-0.7-0.5    C75.4,152.6,75.7,152.4,76.1,152.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.8,152.2c0.4,0,0.7,0.2,0.7,0.5c0,0.3-0.3,0.5-0.7,0.5c-0.4,0-0.7-0.2-0.7-0.5   C78.1,152.4,78.4,152.2,78.8,152.2L78.8,152.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M78.8,152.2c0.4,0,0.7,0.2,0.7,0.5c0,0.3-0.3,0.5-0.7,0.5c-0.4,0-0.7-0.2-0.7-0.5    C78.1,152.4,78.4,152.2,78.8,152.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.5,151.9c0.4,0,0.7,0.2,0.7,0.5c0,0.3-0.3,0.5-0.7,0.5c-0.4,0-0.7-0.2-0.7-0.5   C80.8,152.1,81.1,151.9,81.5,151.9L81.5,151.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 81.5,
    cy: 152.4,
    rx: 0.7,
    ry: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.3,159.9l14.8,11.9L67.3,159.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.2,171.7 67.3,160 67.4,159.8 82.2,171.7   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68.8,159.9l13.3,10.6L68.8,159.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.2,170.4 68.7,160 68.9,159.8 82.2,170.4   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.8,160.4l11.3,8.8L70.8,160.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.2,169.1 70.7,160.5 70.9,160.3 82.2,169.1   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M72.3,160.4l9.9,7.5L72.3,160.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.2,167.8 72.2,160.5 72.3,160.3 82.2,167.8   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.7,160.4l8.4,6.2L73.7,160.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.2,166.4 73.7,160.5 73.8,160.3 82.2,166.4   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.2,160.4l6.9,4.8L75.2,160.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.2,165.1 75.2,160.5 75.3,160.3 82.2,165.1   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M76.7,160.4l5.4,3.5L76.7,160.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.2,163.8 76.6,160.5 76.8,160.3 82.2,163.8   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.2,160.4l3.9,2.6L78.2,160.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M78.2,160.4l3.9,2.6L78.2,160.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M79.7,160.4l2.5,1.8L79.7,160.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M79.7,160.4l2.5,1.8L79.7,160.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.1,160.4l1,0.9L81.1,160.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M81.1,160.4l1,0.9L81.1,160.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.3,161.3l14.8,11.9L67.3,161.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.2,173.1 67.3,161.4 67.4,161.2 82.2,173.1   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.1,159.9l-16.3,13.2L82.1,159.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "65.9,173.2 82.1,159.9 82.2,160 65.9,173.2   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M80.7,159.9l-14.3,11.4L80.7,159.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "66.4,171.5 80.6,159.8 80.7,160 66.4,171.5   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.7,160.4l-11.3,8.8L78.7,160.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "67.4,169.3 78.6,160.3 78.8,160.5 67.4,169.3   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.2,160.4l-9.9,7.5L77.2,160.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "67.4,168 77.1,160.3 77.3,160.5 67.4,168   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.7,160.4l-8.4,6.2L75.7,160.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "67.4,166.7 75.6,160.3 75.8,160.5 67.4,166.7   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.2,160.4l-6.9,4.8L74.2,160.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "67.4,165.3 74.2,160.3 74.3,160.5 67.4,165.3   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M72.8,160.4l-5.4,3.5L72.8,160.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "67.4,164 72.7,160.3 72.8,160.5 67.4,164   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M71.3,160.4l-3.9,2.6L71.3,160.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M71.3,160.4l-3.9,2.6L71.3,160.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M69.8,160.4l-2.5,1.8L69.8,160.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M69.8,160.4l-2.5,1.8L69.8,160.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68.3,160.4l-1,0.9L68.3,160.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M68.3,160.4l-1,0.9L68.3,160.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.1,161.3l-16.3,13.2L82.1,161.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "65.9,174.6 82.1,161.2 82.2,161.4 65.9,174.6   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.1,162.6l-16.3,13.2L82.1,162.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "65.9,175.9 82.1,162.5 82.2,162.7 65.9,175.9   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.1,163.9l-16.3,13.2L82.1,163.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "65.9,177.2 82.1,163.8 82.2,164 65.9,177.2   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.1,165.2l-16.3,13.2L82.1,165.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "65.9,178.5 82.1,165.1 82.2,165.3 65.9,178.5   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.1,166.5l-16.3,13.2L82.1,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "65.9,179.8 82.1,166.5 82.2,166.6 65.9,179.8   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.1,167.9l-16.3,13.2L82.1,167.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "65.9,181.2 82.1,167.8 82.2,168 65.9,181.2   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.1,169.2l-16.3,13.2L82.1,169.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "65.9,182.5 82.1,169.1 82.2,169.3 65.9,182.5   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.1,170.5l-16.3,13.2L82.1,170.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "65.9,183.8 82.1,170.4 82.2,170.6 65.9,183.8   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.1,171.8l-15.3,12.3L82.1,171.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "66.9,184.2 82.1,171.7 82.2,171.9 66.9,184.2   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.1,173.1l-13.8,11L82.1,173.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "68.4,184.2 82.1,173.1 82.2,173.2 68.4,184.2   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.6,174.9l-10.9,8.8L81.6,174.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "70.9,183.8 81.6,174.8 81.7,175 70.9,183.8   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.1,176.7l-8.9,7L81.1,176.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "72.3,183.8 81.1,176.6 81.2,176.8 72.3,183.8   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M80.2,178.9l-4.4,3.5L80.2,178.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M80.2,178.9l-4.4,3.5L80.2,178.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.3,162.6L81.6,174L67.3,162.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "81.7,173.9 67.3,162.7 67.4,162.5 81.7,173.9   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.3,163.9l14.3,11.4L67.3,163.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "81.7,175.3 67.3,164 67.4,163.8 81.7,175.3   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.3,165.2l13.8,11L67.3,165.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "81.2,176.1 67.3,165.3 67.4,165.1 81.2,176.1   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.3,166.5l13.8,11L67.3,166.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "81.2,177.5 67.3,166.6 67.4,166.4 81.2,177.5   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.3,167.9l13.3,10.6L67.3,167.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "80.7,178.3 67.3,168 67.4,167.8 80.7,178.3   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M66.8,168.7l13.3,10.6L66.8,168.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "80.2,179.2 66.8,168.8 66.9,168.6 80.2,179.2   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M66.8,170.1l12.3,9.7L66.8,170.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "79.3,179.7 66.8,170.2 66.9,170 79.3,179.7   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M66.3,170.9l12.3,9.7L66.3,170.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "78.8,180.5 66.3,171 66.4,170.8 78.8,180.5   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.9,171.8l11.8,9.2L65.9,171.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77.8,181 65.8,171.9 65.9,171.7 77.8,181   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.9,173.1l11.3,8.8L65.9,173.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77.3,181.9 65.8,173.2 65.9,173.1 77.3,181.9   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.9,174.5l9.9,7.9L65.9,174.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "75.8,182.3 65.8,174.6 65.9,174.4 75.8,182.3   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.3,157.7v2.2c4.9,0.7,9.9,0.7,14.8,0v-2.2C77.2,158.5,72.3,158.5,67.3,157.7L67.3,157.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74.7,160.6c-2.5,0-5-0.2-7.4-0.6l-0.1-2.3c5.2,0.5,10,0.6,14.9-0.1l0.1,2.3    C79.7,160.4,77.2,160.6,74.7,160.6L74.7,160.6z M67.3,157.9l0.1,2.1c4.7,0.5,9.8,0.6,14.7-0.1l-0.1-2.1    C77.4,158.7,72.2,158.6,67.3,157.9L67.3,157.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.9,175.8l8.9,7L65.9,175.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "74.8,182.7 65.8,175.9 65.9,175.7 74.8,182.7   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.9,177.1l7.9,6.2L65.9,177.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "73.8,183.2 65.8,177.2 65.9,177 73.8,183.2   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.9,178.4l6.9,5.3L65.9,178.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "72.8,183.6 65.8,178.5 65.9,178.3 72.8,183.6   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.9,179.8l4.9,4L65.9,179.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "70.9,183.6 65.8,179.8 65.9,179.7 70.9,183.6   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.9,181.1l3.9,3.1L65.9,181.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M65.9,181.1l3.9,3.1L65.9,181.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.9,182.4l2.5,1.8L65.9,182.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M65.9,182.4l2.5,1.8L65.9,182.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68,158.5c0.4,0,0.7,0.2,0.7,0.5s-0.3,0.5-0.7,0.5s-0.7-0.2-0.7-0.5S67.6,158.5,68,158.5L68,158.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 68,
    cy: 159,
    rx: 0.7,
    ry: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.7,158.8c0.4,0,0.7,0.2,0.7,0.5c0,0.3-0.3,0.5-0.7,0.5s-0.7-0.2-0.7-0.5C70,159,70.3,158.8,70.7,158.8   L70.7,158.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 70.7,
    cy: 159.2,
    rx: 0.7,
    ry: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.4,159c0.4,0,0.7,0.2,0.7,0.5c0,0.3-0.3,0.5-0.7,0.5c-0.4,0-0.7-0.2-0.7-0.5C72.7,159.2,73,159,73.4,159   L73.4,159z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M73.4,159c0.4,0,0.7,0.2,0.7,0.5c0,0.3-0.3,0.5-0.7,0.5c-0.4,0-0.7-0.2-0.7-0.5C72.7,159.2,73,159,73.4,159z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M76.1,159c0.4,0,0.7,0.2,0.7,0.5c0,0.3-0.3,0.5-0.7,0.5c-0.4,0-0.7-0.2-0.7-0.5C75.4,159.2,75.7,159,76.1,159   L76.1,159z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M76.1,159c0.4,0,0.7,0.2,0.7,0.5c0,0.3-0.3,0.5-0.7,0.5c-0.4,0-0.7-0.2-0.7-0.5C75.4,159.2,75.7,159,76.1,159    z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.8,158.8c0.4,0,0.7,0.2,0.7,0.5c0,0.3-0.3,0.5-0.7,0.5c-0.4,0-0.7-0.2-0.7-0.5   C78.1,159,78.4,158.8,78.8,158.8L78.8,158.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M78.8,158.8c0.4,0,0.7,0.2,0.7,0.5c0,0.3-0.3,0.5-0.7,0.5c-0.4,0-0.7-0.2-0.7-0.5    C78.1,159,78.4,158.8,78.8,158.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.5,158.5c0.4,0,0.7,0.2,0.7,0.5s-0.3,0.5-0.7,0.5c-0.4,0-0.7-0.2-0.7-0.5S81.1,158.5,81.5,158.5L81.5,158.5   z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 81.5,
    cy: 159,
    rx: 0.7,
    ry: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M46.1,180.6l17.8-9.2L46.1,180.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "46.2,180.7 46,180.5 63.8,171.3 46.2,180.7   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.1,180.2l16.8-8.8L45.1,180.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "45.2,180.3 45.1,180.1 61.8,171.3 45.2,180.3   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.6,179.3l15.3-7.9L44.6,179.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "44.7,179.4 44.6,179.2 59.9,171.3 44.7,179.4   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.1,178.4l13.3-7L44.1,178.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "44.2,178.5 44.1,178.3 57.4,171.3 44.2,178.5   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.1,177.5l12.3-6.2L43.1,177.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "43.2,177.7 43.1,177.4 55.4,171.3 43.2,177.7   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.6,176.2l8.4-4.4L43.6,176.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "43.7,176.3 43.6,176.1 52,171.7 43.7,176.3   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.1,175.3l6.4-3.5L43.1,175.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "43.2,175.5 43.1,175.2 49.5,171.7 43.2,175.5   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.1,174l4.4-2.2L43.1,174z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M43.1,174l4.4-2.2L43.1,174z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.6,181.1l16.8-8.8L47.6,181.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "47.7,181.2 47.5,181 64.3,172.2 47.7,181.2   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.1,181.5l15.8-8.4L49.1,181.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "49.1,181.6 49,181.4 64.8,173 49.1,181.6   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.6,182l14.8-7.9L50.6,182z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "50.6,182.1 50.5,181.8 65.3,173.9 50.6,182.1   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52,182.4l12.3-6.6L52,182.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "52.1,182.5 52,182.3 64.3,175.7 52.1,182.5   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54,182.4l10.9-5.7L54,182.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "54.1,182.5 53.9,182.3 64.8,176.6 54.1,182.5   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.5,182.8l9.4-4.8L55.5,182.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "55.5,182.9 55.4,182.7 64.8,177.9 55.5,182.9   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57,183.3l7.4-4L57,183.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "57,183.4 56.9,183.2 64.3,179.2 57,183.4   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.9,183.3l5.9-3.1L58.9,183.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "59,183.4 58.9,183.2 64.8,180.1 59,183.4   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.9,183.7l3.9-2.2L60.9,183.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M60.9,183.7l3.9-2.2L60.9,183.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.9,183.7l2.5-1.3L62.9,183.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M62.9,183.7l2.5-1.3L62.9,183.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M66.3,170.9h-2.5c-0.8,4.4-0.8,8.8,0,13.2h2.5C65.5,179.8,65.5,175.3,66.3,170.9L66.3,170.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M66.5,184.3h-2.6c-0.9-4.5-0.9-9-0.1-13.4l2.6-0.1c-0.7,4.5-0.7,8.9,0.1,13.3L66.5,184.3L66.5,184.3z     M66.2,170.9l-2.4,0.2c-0.7,4.3-0.7,8.7,0.1,13.1l2.2-0.1C65.4,179.7,65.4,175.3,66.2,170.9L66.2,170.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.2,177.1l5.9-4.4L37.2,177.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "37.3,177.2 37.1,177 43.1,172.6 37.3,177.2   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.2,174l5.9,5.3L37.2,174z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "43.2,179.2 37.1,174.1 37.3,173.9 43.2,179.2   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M46.1,171.8l-3,0.4c-0.7,2.8-0.7,5.1,0,7.9l3,0.9C45.5,178.3,45.5,174.6,46.1,171.8L46.1,171.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M46.3,181.3l-3.2-0.9c-0.7-2.9-0.7-5.3-0.1-8.1l3.1-0.5c-0.5,2.9-0.5,6.5,0.1,9.3L46.3,181.3L46.3,181.3z     M46,171.8l-2.8,0.6c-0.6,2.7-0.6,5,0.1,7.8l2.7,0.7C45.3,178.1,45.3,174.6,46,171.8L46,171.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.1,149.8v-2.2c-2.2,0-3.7-1.3-3.7-2.6l-7.4,0c0,1.3-1.5,2.6-3.7,2.6v2.2H82.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M82.2,150H67.3l-0.1-2.3c2.3-0.1,3.7-1.4,3.7-2.6l7.5-0.1c0.1,0.7,0.5,1.4,1.1,1.8c0.7,0.5,1.6,0.8,2.6,0.8    L82.2,150L82.2,150z M78.3,145l-7.3,0.1c0.1,1.2-1.3,2.6-3.7,2.6l0.1,2.1l14.5-0.1v-2.1c-1,0.1-1.9-0.2-2.6-0.7    C78.7,146.4,78.3,145.7,78.3,145L78.3,145z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    height: 2.6,
    width: 6.3,
    x: 71.6,
    y: 142.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M78,145.1h-6.5l-0.1-2.8l6.5-0.1L78,145.1L78,145.1z M77.8,142.3l-6.2,0.1l0.1,2.5l6.1-0.1V142.3L77.8,142.3z    "
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    height: 2.6,
    width: 5.3,
    x: 72.1,
    y: 139.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M77.5,142.5h-5.4l-0.1-2.8l5.4-0.1L77.5,142.5L77.5,142.5z M77.2,139.7l-5.2,0.1l0.1,2.5l5-0.1V139.7    L77.2,139.7z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    height: 2.6,
    width: 5.3,
    x: 72.1,
    y: 137.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M77.5,139.8h-5.4l-0.1-2.8l5.4-0.1L77.5,139.8L77.5,139.8z M77.2,137.1l-5.2,0.1l0.1,2.5l5-0.1V137.1    L77.2,137.1z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    height: 3.5,
    width: 4.2,
    x: 72.6,
    y: 133.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M77,137.2h-4.4l-0.1-3.6l4.4-0.1L77,137.2L77,137.2z M76.7,133.5l-4.1,0.1l0.1,3.4l4-0.1V133.5L76.7,133.5z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    height: 3.1,
    width: 4.6,
    x: 72.4,
    y: 130.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M77.1,133.7h-4.7l-0.1-3.2l4.7-0.1L77.1,133.7L77.1,133.7z M76.9,130.5l-4.5,0.1l0.1,3l4.3-0.1V130.5    L76.9,130.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75,123.4c3.4,0,6.1,1.9,6.1,4.2c0,2.3-2.7,4.2-6.1,4.2c-3.4,0-6.1-1.9-6.1-4.2   C68.9,125.3,71.6,123.4,75,123.4L75,123.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75,131.9c-3.4,0-6.2-1.9-6.2-4.3c0-2.4,2.8-4.3,6.2-4.3c3.4,0,6.2,1.9,6.2,4.3C81.2,130,78.4,131.9,75,131.9    L75,131.9z M75,123.5c-3.3,0-6,1.8-6,4.1c0,2.2,2.7,4.1,6,4.1c3.3,0,6-1.8,6-4.1C81,125.4,78.3,123.5,75,123.5L75,123.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78,127.4c0,1.2,1.5,3.1,1.5,3.1c-1.1,0.8-2.9,1.3-4.6,1.3c-1.7,0-3.8-0.3-4.6-1.3c0,0,1.5-1.9,1.5-3.1   c0-1.2-1.5-2.6-1.5-2.6c1.1-0.8,2.9-1.3,4.6-1.3c1.7,0,3.5,0.6,4.6,1.3C79.6,124.7,78,126.2,78,127.4L78,127.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75,131.9c-0.8,0-3.7-0.1-4.7-1.4c0-0.2,1.5-2.1,1.5-3.2c0-1.1-1.5-2.5-1.5-2.5c2.4-2,7-1.8,9.3-0.2    c0,0.2-1.5,1.7-1.5,2.7c0,1.1,1.5,3,1.5,3C78.5,131.4,76.6,131.9,75,131.9L75,131.9z M70.5,124.8c0.2,0,1.6,1.4,1.6,2.5    c0,1.2-1.5,3.1-1.6,3.2c0.9,1,3.7,1.1,4.5,1.1c1.6,0,3.4-0.5,4.5-1.3c-0.2,0-1.6-1.8-1.6-3c0-1.2,1.5-2.7,1.6-2.7    C77.2,123.5,72.8,123.3,70.5,124.8L70.5,124.8L70.5,124.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77,127.4c0,1.2,1.5,3.5,1.5,3.5c-1.1,0.8-1.9,0.9-3.6,0.9c-1.7,0-2.8,0.1-3.6-0.9c0,0,1.5-2.4,1.5-3.5   c0-1.2-1.5-3.1-1.5-3.1c1.1-0.8,1.9-0.9,3.6-0.9c1.7,0,2.5,0.1,3.6,0.9C78.5,124.3,77,126.2,77,127.4L77,127.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74,131.9c-1.1,0-2-0.1-2.7-0.9c0-0.2,1.5-2.5,1.5-3.6c0-1.1-1.5-3-1.5-3c1.1-0.9,2-1.1,3.7-1.1    c1.7,0,2.5,0.1,3.6,0.9c0,0.2-1.5,2.1-1.5,3.2c0,1.1,1.5,3.4,1.5,3.5c-1.2,0.9-1.9,1.1-3.7,1.1L74,131.9L74,131.9z M71.5,124.4    c0.2,0,1.6,1.8,1.6,3c0,1.2-1.5,3.5-1.5,3.6c0.6,0.6,1.4,0.7,2.5,0.7v0.1l0.5-0.1c2.2,0,3-0.1,4-0.9h0c-0.1,0-1.6-2.3-1.6-3.4    c0-1.2,1.5-3.1,1.6-3.2c-1-0.6-1.8-0.7-3.5-0.7C73.3,123.5,72.6,123.7,71.5,124.4C71.5,124.4,71.5,124.4,71.5,124.4L71.5,124.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68.9,126.5c0.8,0,1.5,0.6,1.5,1.3c0,0.7-0.7,1.3-1.5,1.3c-0.8,0-1.5-0.6-1.5-1.3   C67.3,127.1,68,126.5,68.9,126.5L68.9,126.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M68.9,129.3c-0.9,0-1.7-0.6-1.7-1.4c0-1.6,3.3-1.6,3.3,0C70.5,128.6,69.8,129.3,68.9,129.3L68.9,129.3z     M68.9,126.6c-0.8,0-1.4,0.5-1.4,1.2c0,1.3,2.8,1.3,2.8,0C70.3,127.2,69.6,126.6,68.9,126.6L68.9,126.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.1,126.5c0.8,0,1.5,0.6,1.5,1.3c0,0.7-0.7,1.3-1.5,1.3c-0.8,0-1.5-0.6-1.5-1.3   C79.6,127.1,80.3,126.5,81.1,126.5L81.1,126.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.1,129.3c-0.9,0-1.7-0.6-1.7-1.4c0-1.6,3.3-1.6,3.3,0C82.8,128.6,82,129.3,81.1,129.3L81.1,129.3z     M81.1,126.6c-0.8,0-1.4,0.5-1.4,1.2c0,1.3,2.8,1.3,2.8,0C82.5,127.2,81.9,126.6,81.1,126.6L81.1,126.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75,126.5c0.8,0,1.5,0.6,1.5,1.3c0,0.7-0.7,1.3-1.5,1.3c-0.8,0-1.5-0.6-1.5-1.3   C73.5,127.1,74.1,126.5,75,126.5L75,126.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75,129.3c-0.9,0-1.7-0.6-1.7-1.4c0-1.6,3.3-1.6,3.3,0C76.6,128.6,75.9,129.3,75,129.3L75,129.3z M75,126.6    c-0.8,0-1.4,0.5-1.4,1.2c0,1.3,2.8,1.3,2.8,0C76.4,127.2,75.8,126.6,75,126.6L75,126.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75,122.1c0.8,0,1.5,0.6,1.5,1.3c0,0.7-0.7,1.3-1.5,1.3c-0.8,0-1.5-0.6-1.5-1.3   C73.5,122.7,74.1,122.1,75,122.1L75,122.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75,124.9c-0.9,0-1.7-0.6-1.7-1.4c0-1.6,3.3-1.6,3.3,0C76.6,124.2,75.9,124.9,75,124.9L75,124.9z M75,122.2    c-0.8,0-1.4,0.5-1.4,1.2c0,1.3,2.8,1.3,2.8,0C76.4,122.8,75.8,122.2,75,122.2L75,122.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.5,147.2c0.9,0,1.6,0.6,1.6,1.3c0,0.7-0.7,1.3-1.6,1.3c-0.9,0-1.6-0.6-1.6-1.3   C68.9,147.8,69.6,147.2,70.5,147.2L70.5,147.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M70.5,150c-0.9,0-1.7-0.6-1.7-1.4c0-1.6,3.4-1.6,3.4,0C72.2,149.3,71.4,150,70.5,150L70.5,150z M70.5,147.3    c-0.8,0-1.4,0.5-1.4,1.2c0,1.3,2.9,1.3,2.9,0C72,147.8,71.3,147.3,70.5,147.3L70.5,147.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.9,147.2c0.9,0,1.6,0.6,1.6,1.3c0,0.7-0.7,1.3-1.6,1.3c-0.9,0-1.6-0.6-1.6-1.3   C77.4,147.8,78.1,147.2,78.9,147.2L78.9,147.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M78.9,150c-0.9,0-1.7-0.6-1.7-1.4c0-1.6,3.4-1.6,3.4,0C80.7,149.3,79.9,150,78.9,150L78.9,150z M78.9,147.3    c-0.8,0-1.4,0.5-1.4,1.2c0,1.3,2.9,1.3,2.9,0C80.4,147.8,79.8,147.3,78.9,147.3L78.9,147.3z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "71,145 78.4,145 74.7,148.9  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74.7,149.1l-3.8-4.1l7.5-0.2L74.7,149.1L74.7,149.1z M78.3,144.9l-7.3,0.2l3.7,3.7L78.3,144.9L78.3,144.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.7,146.3c1.2,0,2.1,0.8,2.1,1.8c0,1-0.9,1.8-2.1,1.8c-1.2,0-2.1-0.8-2.1-1.8   C72.6,147.1,73.6,146.3,74.7,146.3L74.7,146.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74.7,150c-1.2,0-2.2-0.8-2.2-1.9c0-1,1-1.9,2.2-1.9c1.2,0,2.2,0.8,2.2,1.9C77,149.1,76,150,74.7,150    L74.7,150z M74.7,146.4c-1.1,0-2,0.7-2,1.6c0,1.8,4,1.8,4,0C76.7,147.2,75.8,146.4,74.7,146.4L74.7,146.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.2,161.3h10.1c0.3,0,0.6,0.2,0.6,0.5v1.7c0,0.3-0.3,0.5-0.6,0.5H67.2c-0.3,0-0.6-0.2-0.6-0.5v-1.7   C66.6,161.5,66.9,161.3,67.2,161.3L67.2,161.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M77.3,164H67.2c-0.4,0-0.7-0.3-0.7-0.6v-1.7c0-0.3,0.3-0.6,0.7-0.6h10.1c0.4,0,0.7,0.3,0.7,0.6v1.7    C78.1,163.8,77.7,164,77.3,164L77.3,164z M67.2,161.4l-0.5,2l10.6,0.3c0.3,0,0.5-0.2,0.5-0.3v-1.7L67.2,161.4L67.2,161.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.4,159.1c-1.4,0-2.5,1-2.5,2.3v2c0,1.3,1.1,2.3,2.5,2.3c1.4,0,2.5-1,2.5-2.3v-2   C83.9,160.1,82.8,159.1,81.4,159.1L81.4,159.1z M81.4,160c-0.8,0-1.5,0.8-1.5,1.8v1.2c0,1,0.7,1.8,1.5,1.8s1.5-0.8,1.5-1.8v-1.2   C82.9,160.8,82.2,160,81.4,160L81.4,160z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.4,165.8c-1.4,0-2.6-1.1-2.6-2.4v-2c0-1.3,1.2-2.4,2.6-2.4c1.4,0,2.6,1.1,2.6,2.4v2    C84,164.7,82.8,165.8,81.4,165.8L81.4,165.8z M81.4,159.2c-1.3,0-2.3,1-2.3,2.2v2c0,1.2,1,2.2,2.3,2.2c1.3,0,2.3-1,2.3-2.2v-2    C83.7,160.2,82.7,159.2,81.4,159.2L81.4,159.2z M81.4,164.9c-0.9,0-1.6-0.9-1.6-2v-1.2c0-1.1,0.7-2,1.6-2c0.9,0,1.6,0.9,1.6,2v1.2    C83,164,82.3,164.9,81.4,164.9L81.4,164.9z M81.4,160.1c-0.7,0-1.4,0.8-1.4,1.7v1.2c0,1.9,2.7,1.9,2.7,0v-1.2    C82.8,160.8,82.1,160.1,81.4,160.1L81.4,160.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68.6,159.5c-0.8,0-1.5,0.8-1.5,1.8v2c0,1,0.7,1.8,1.5,1.8c0.8,0,1.5-0.8,1.5-1.8v-2   C70,160.3,69.4,159.5,68.6,159.5L68.6,159.5z M68.6,158.6c-1.4,0-2.5,1-2.5,2.3v2.9c0,1.3,1.1,2.3,2.5,2.3c1.4,0,2.5-1,2.5-2.3   v-2.9C71,159.7,69.9,158.6,68.6,158.6L68.6,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M68.6,166.2c-1.4,0-2.6-1.1-2.6-2.4v-2.9c0-1.3,1.2-2.4,2.6-2.4c1.4,0,2.6,1.1,2.6,2.4v2.9    C71.2,165.2,70,166.2,68.6,166.2L68.6,166.2z M68.6,158.8c-1.3,0-2.3,1-2.3,2.2v2.9c0,1.2,1,2.2,2.3,2.2c1.3,0,2.4-1,2.4-2.2v-2.9    C70.9,159.7,69.9,158.8,68.6,158.8L68.6,158.8z M68.6,165.4c-0.9,0-1.6-0.9-1.6-2v-2c0-1.1,0.7-2,1.6-2c0.9,0,1.6,0.9,1.6,2v2    C70.2,164.5,69.5,165.4,68.6,165.4L68.6,165.4z M68.6,159.6c-0.7,0-1.4,0.8-1.4,1.7v2c0,1.9,2.7,1.9,2.7,0v-2    C69.9,160.4,69.3,159.6,68.6,159.6L68.6,159.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64.6,160.4c-0.8,0-1.5,0.8-1.5,1.8v0.5c0,1,0.7,1.8,1.5,1.8c0.8,0,1.5-0.8,1.5-1.8v-0.5   C66.1,161.2,65.4,160.4,64.6,160.4L64.6,160.4z M64.6,159.5c-1.4,0-2.5,1-2.5,2.3v1.3c0,1.3,1.1,2.3,2.5,2.3c1.4,0,2.5-1,2.5-2.3   v-1.3C67.1,160.5,66,159.5,64.6,159.5L64.6,159.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.6,165.6c-1.4,0-2.6-1.1-2.6-2.4v-1.3c0-1.3,1.2-2.4,2.6-2.4c1.4,0,2.6,1.1,2.6,2.4v1.3    C67.2,164.5,66,165.6,64.6,165.6L64.6,165.6z M64.6,159.6c-1.3,0-2.3,1-2.3,2.2v1.3c0,1.2,1,2.2,2.3,2.2c1.3,0,2.3-1,2.3-2.2v-1.3    C67,160.6,65.9,159.6,64.6,159.6L64.6,159.6z M64.6,164.7c-0.9,0-1.6-0.9-1.6-2c0-3.1,3.2-2.6,3.2-0.5    C66.2,163.8,65.5,164.7,64.6,164.7L64.6,164.7z M64.6,160.5c-0.7,0-1.4,0.8-1.4,1.7c0,2.8,2.7,2.4,2.7,0.5    C66,161.3,65.4,160.5,64.6,160.5L64.6,160.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.7,159.2c-1.5,0-2.7,0.9-2.7,2.1v2.3c0,1.1,1.2,2.1,2.7,2.1c1.5,0,2.7-0.9,2.7-2.1v-2.3   C61.4,160.1,60.2,159.2,58.7,159.2L58.7,159.2z M58.7,158.2c-2.5,0-4.4,1.1-4.4,2.6v3.2c0,1.4,2,2.6,4.4,2.6c2.5,0,4.4-1.1,4.4-2.6   v-3.2C63.1,159.3,61.2,158.2,58.7,158.2L58.7,158.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.7,166.7c-2.5,0-4.6-1.2-4.6-2.7v-3.2c0-1.5,2-2.7,4.6-2.7c2.6,0,4.6,1.2,4.6,2.7v3.2    C63.3,165.5,61.2,166.7,58.7,166.7L58.7,166.7z M58.7,158.3c-2.4,0-4.3,1.1-4.3,2.4v3.2c0,1.3,1.9,2.4,4.3,2.4    c2.4,0,4.3-1.1,4.3-2.4v-3.2C63,159.4,61.1,158.3,58.7,158.3L58.7,158.3z M58.7,165.7c-1.5,0-2.8-1-2.8-2.2v-2.3    c0-1.2,1.3-2.2,2.8-2.2c1.5,0,2.8,1,2.8,2.2v2.3C61.5,164.7,60.2,165.7,58.7,165.7L58.7,165.7z M58.7,159.3    c-1.4,0-2.5,0.9-2.5,1.9v2.3c0,1.1,1.1,1.9,2.5,1.9c1.4,0,2.5-0.9,2.5-1.9v-2.3C61.2,160.2,60.1,159.3,58.7,159.3L58.7,159.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M90.8,159.6c-1.5,0-2.7,0.9-2.7,2.1v2.3c0,1.1,1.2,2.1,2.7,2.1c1.5,0,2.7-0.9,2.7-2.1v-2.3   C93.4,160.5,92.3,159.6,90.8,159.6L90.8,159.6z M90.8,158.6c-2.5,0-4.4,1.1-4.4,2.6v3.2c0,1.4,2,2.6,4.4,2.6s4.4-1.1,4.4-2.6v-3.2   C95.2,159.8,93.2,158.6,90.8,158.6L90.8,158.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M90.8,167.1c-2.6,0-4.6-1.2-4.6-2.7v-3.2c0-1.5,2-2.7,4.6-2.7c2.6,0,4.6,1.2,4.6,2.7v3.2    C95.3,165.9,93.3,167.1,90.8,167.1L90.8,167.1z M90.8,158.8c-2.4,0-4.3,1.1-4.3,2.4v3.2c0,1.3,1.9,2.4,4.3,2.4    c2.4,0,4.3-1.1,4.3-2.4v-3.2C95.1,159.9,93.2,158.8,90.8,158.8L90.8,158.8z M90.8,166.1c-1.5,0-2.8-1-2.8-2.2v-2.3    c0-1.2,1.3-2.2,2.8-2.2c1.5,0,2.8,1,2.8,2.2v2.3C93.6,165.2,92.3,166.1,90.8,166.1L90.8,166.1z M90.8,159.7    c-1.4,0-2.5,0.9-2.5,1.9v2.3c0,1.1,1.1,1.9,2.5,1.9c1.4,0,2.5-0.9,2.5-1.9v-2.3C93.3,160.6,92.2,159.7,90.8,159.7L90.8,159.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.7,161.3H88c0.2,0,0.3,0.2,0.3,0.5v1.7c0,0.3-0.1,0.5-0.3,0.5h-5.3c-0.2,0-0.3-0.2-0.3-0.5v-1.7   C82.4,161.5,82.5,161.3,82.7,161.3L82.7,161.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M88,164h-5.4l-0.3-0.6v-1.8l0.5-0.5h5.4l0.3,0.6v1.8L88,164L88,164z M82.7,161.4l-0.2,2l5.5,0.5l0.2-0.5v-1.7    L82.7,161.4L82.7,161.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.1,160.8h3.1c0.1,0,0.2,0.3,0.2,0.6v2.3c0,0.3-0.1,0.6-0.2,0.6h-3.1c-0.1,0-0.2-0.3-0.2-0.6v-2.3   C76.9,161.1,77,160.8,77.1,160.8L77.1,160.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M80.2,164.5h-3.1c-0.2,0-0.3-0.4-0.3-0.7v-2.3c0-0.4,0.1-0.7,0.3-0.7h3.1c0.2,0,0.3,0.4,0.3,0.7v2.3    C80.5,164.1,80.5,164.5,80.2,164.5L80.2,164.5z M77.1,161l-0.1,2.8l3.1,0.5l0.1-2.8L77.1,161L77.1,161z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.9,160.8h3.1c0.1,0,0.2,0.3,0.2,0.6v2.3c0,0.3-0.1,0.6-0.2,0.6h-3.1c-0.1,0-0.2-0.3-0.2-0.6v-2.3   C60.7,161.1,60.7,160.8,60.9,160.8L60.9,160.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M63.9,164.5h-3.1c-0.2,0-0.3-0.4-0.3-0.7v-2.3c0-0.4,0.1-0.7,0.3-0.7h3.1c0.2,0,0.3,0.4,0.3,0.7v2.3    C64.2,164.1,64.2,164.5,63.9,164.5L63.9,164.5z M60.9,161l-0.1,2.8l3.1,0.5l0.1-2.8L60.9,161L60.9,161z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.2,160.4h6.2c0.2,0,0.4,0.3,0.4,0.8v2.8c0,0.4-0.2,0.8-0.4,0.8h-6.2c-0.2,0-0.4-0.3-0.4-0.8v-2.8   C49.8,160.7,50,160.4,50.2,160.4L50.2,160.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M56.3,164.9h-6.2c-0.3,0-0.5-0.4-0.5-0.9v-2.8c0-0.5,0.2-0.9,0.5-0.9h6.2c0.3,0,0.5,0.4,0.5,0.9v2.8    C56.8,164.5,56.6,164.9,56.3,164.9L56.3,164.9z M50.2,160.5c-0.1,0-0.3,0.3-0.3,0.7v2.8c0,0.4,0.2,0.6,0.3,0.6h6.2    c0.1,0,0.2-0.3,0.2-0.6v-2.8c0-0.4-0.1-0.7-0.2-0.7H50.2L50.2,160.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.1,160.8h5.7c0.2,0,0.3,0.3,0.3,0.8v2.8c0,0.4-0.2,0.8-0.3,0.8h-5.7c-0.2,0-0.3-0.3-0.3-0.8v-2.8   C92.7,161.2,92.9,160.8,93.1,160.8L93.1,160.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.8,165.4h-5.7c-0.3,0-0.5-0.5-0.5-0.9v-2.8c0-0.5,0.2-0.9,0.5-0.9h5.7c0.3,0,0.5,0.4,0.5,0.9v2.8    C99.3,164.9,99.1,165.4,98.8,165.4L98.8,165.4z M93.1,161c-0.1,0-0.2,0.2-0.2,0.6v2.8c0,0.4,0.1,0.7,0.2,0.7h5.7    c0.1,0,0.2-0.2,0.2-0.7v-2.8c0-0.4-0.1-0.6-0.2-0.6H93.1L93.1,161z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOman);
export default __webpack_public_path__ + "static/media/oman.8f4edf30fdc148a364e741b423bbb5a9.svg";
export { ForwardRef as ReactComponent };